import moment from 'moment';
export const toCustomZoneTime = (
  time: string,
  format: string,
  zone: {
    posfix: string;
    value: number;
  }
) =>
  time
    ? `${moment(time).utc().add(zone.value, 'h').format(format)} ${zone.posfix}`
    : '';

export const PST_ZONE = {
  posfix: 'PST',
  value: -8,
};

export const handleDebounce = (
  reference: NodeJS.Timeout | null,
  handle: () => void,
  delay: number,
  setCustomTimeout: (value: NodeJS.Timeout) => void
) => {
  if (reference) {
    clearTimeout(reference);
    reference = null;
  }

  setCustomTimeout(setTimeout(handle, delay));
};

export const TIME_FORMAT = 'MM/DD/YYYY HH:mm';

export const generateYears = (begin: number, end: number): number[] => {
  const result = [];
  for (let i = begin; i <= end; i++) {
    result.unshift(i);
  }

  return result;
};
